import { codeMap, http } from './http';

/**
 * VICS 월보고 진행 · 결산 할 일 — /api/vics-submissions · /api/closing-tasks.
 * VICS 진행은 한 칸씩만 움직인다(서버가 때를 적는다). 결산 할 일은 끝낸 때(doneAt)만 켜고 끈다.
 */
export const VICS_STATUS = codeMap({ drafting: '작성 중', checked: '점검 완료', entered: 'VICS 입력', confirmed: '확정' } as const);
export type VicsStatus = '작성 중' | '점검 완료' | 'VICS 입력' | '확정';
export const VICS_STEPS: VicsStatus[] = ['작성 중', '점검 완료', 'VICS 입력', '확정'];

export interface VicsSubmission { id: number; vehicleId: number; month: string; status: VicsStatus; updatedAt: string }
const toUi = (r: any): VicsSubmission => ({ id: r.id, vehicleId: r.vehicleId, month: r.month, status: VICS_STATUS.toUi(r.status)!, updatedAt: r.updatedAt });

export const vicsApi = {
  async list(): Promise<VicsSubmission[]> { return (await http.get<any[]>('/vics-submissions')).map(toUi); },
  // from — 화면이 보고 있던 단계. 서버가 지금 단계와 다르면 막는다(두 번 누르기)
  advance: async (vehicleId: number, month: string, from?: VicsStatus) => toUi(await http.post('/vics-submissions/advance', { vehicleId, month, from: from ? VICS_STATUS.toDb(from) : undefined })),
  revert: async (vehicleId: number, month: string, from?: VicsStatus) => toUi(await http.post('/vics-submissions/revert', { vehicleId, month, from: from ? VICS_STATUS.toDb(from) : undefined })),
  /** 1316 점검용 — 그 회사들의 재무 줄(연도 · 실적/전망) */
  financials: (companyIds: number[]) => companyIds.length
    ? http.get<{ companyId: number; fiscalYear: number; isForecast: boolean; fiscalPeriod: string }[]>('/financials', { companyId: companyIds.join(',') })
    : Promise.resolve([]),
};

export const CLOSING_TASK = codeMap({
  ledger_close: '원장 연간 마감', year_end_valuation: '연말 평가', statements: '결산서 작성 (회계사)',
  audit: '회계감사', lp_approval: '조합원 총회 승인', submit: '제출',
} as const);
export const CLOSING_TASKS = ['ledger_close', 'year_end_valuation', 'statements', 'audit', 'lp_approval', 'submit'] as const;
export type ClosingTaskCode = (typeof CLOSING_TASKS)[number];
export interface ClosingTask { id: number; vehicleId: number; fiscalYear: number; task: ClosingTaskCode; doneAt: string | null }

export const closingApi = {
  list: (fiscalYear: number) => http.get<ClosingTask[]>('/closing-tasks', { fiscalYear }),
  /** 끝냄 ↔ 안 끝냄. 줄이 없으면 만든다 */
  async toggle(row: ClosingTask | undefined, vehicleId: number, fiscalYear: number, task: ClosingTaskCode): Promise<ClosingTask> {
    if (row) return http.patch<ClosingTask>(`/closing-tasks/${row.id}`, { doneAt: row.doneAt ? null : new Date().toISOString() });
    return http.post<ClosingTask>('/closing-tasks', { vehicleId, fiscalYear, task, doneAt: new Date().toISOString() });
  },
};
